module.exports = __webpack_public_path__ + "img/minicorndogs.17eb4bf5.png";